import { grey } from '@material-ui/core/colors';

export const itemBackground = '#f7f9fd';
export const subText = grey['600'];
